<template>
  <div>
    <v-switch
      ref="useAdvancedSwitch"
      :false-value="false"
      :input-value="value"
      :disabled="disabled"
      @click.prevent.stop="switchUseAdvancedSetting"
      label="高度な設定"
    />
  </div>
</template>

<script>
export default {
  name: 'FormAdvancedUse',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async switchUseAdvancedSetting() {
      if (this.value) {
        this.$emit('input', false)
        return
      }
      const result = await this.$confirm(
        '高度な設定を追加しますか？\n※ 設定内容によっては配信量が激減する恐れがあります。',
      )
      this.$refs.useAdvancedSwitch.internalValue = this.value
      this.$emit('input', result)
    },
  },
}
</script>
